import { pxToRemValue } from '../../../../design-tokens/style-utilities';
import { NAVIGATION_VIEWPORT_BREAKPOINTS, } from '../../constants';
export const getNavigationViewportMediaQueryLists = (() => {
    let cache;
    return () => {
        // In order to media query lists to overlap, we need to subtract a small value from the max-width
        const maxWidthNegativeOffset = 0.001;
        if (cache === undefined) {
            cache = [
                {
                    size: 'xxs',
                    mediaQueryList: window.matchMedia(`(max-width: ${pxToRemValue(NAVIGATION_VIEWPORT_BREAKPOINTS.xs) - maxWidthNegativeOffset}rem)`),
                },
                {
                    size: 'xs',
                    mediaQueryList: window.matchMedia(`(min-width: ${pxToRemValue(NAVIGATION_VIEWPORT_BREAKPOINTS.xs)}rem) and (max-width: ${pxToRemValue(NAVIGATION_VIEWPORT_BREAKPOINTS.sm) - maxWidthNegativeOffset}rem)`),
                },
                {
                    size: 'sm',
                    mediaQueryList: window.matchMedia(`(min-width: ${pxToRemValue(NAVIGATION_VIEWPORT_BREAKPOINTS.sm)}rem) and (max-width: ${pxToRemValue(NAVIGATION_VIEWPORT_BREAKPOINTS.md) - maxWidthNegativeOffset}rem)`),
                },
                {
                    size: 'md',
                    mediaQueryList: window.matchMedia(`(min-width: ${pxToRemValue(NAVIGATION_VIEWPORT_BREAKPOINTS.md)}rem) and (max-width: ${pxToRemValue(NAVIGATION_VIEWPORT_BREAKPOINTS.lg) - maxWidthNegativeOffset}rem)`),
                },
                {
                    size: 'lg',
                    mediaQueryList: window.matchMedia(`(min-width: ${pxToRemValue(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}rem) and (max-width: ${pxToRemValue(NAVIGATION_VIEWPORT_BREAKPOINTS.xl) - maxWidthNegativeOffset}rem)`),
                },
                {
                    size: 'xl',
                    mediaQueryList: window.matchMedia(`(min-width: ${pxToRemValue(NAVIGATION_VIEWPORT_BREAKPOINTS.xl)}rem) and (max-width: ${pxToRemValue(NAVIGATION_VIEWPORT_BREAKPOINTS.xxl) - maxWidthNegativeOffset}rem)`),
                },
                {
                    size: 'xxl',
                    mediaQueryList: window.matchMedia(`(min-width: ${pxToRemValue(NAVIGATION_VIEWPORT_BREAKPOINTS.xxl)}rem) and (max-width: ${pxToRemValue(NAVIGATION_VIEWPORT_BREAKPOINTS.xxxl) - maxWidthNegativeOffset}rem)`),
                },
                {
                    size: 'xxxl',
                    mediaQueryList: window.matchMedia(`(min-width: ${pxToRemValue(NAVIGATION_VIEWPORT_BREAKPOINTS.xxxl)}rem)`),
                },
            ];
        }
        return cache;
    };
})();
export const getNavigationViewportBreakpoint = () => {
    var _a;
    if (typeof window === 'undefined' || typeof document === 'undefined')
        return 'xxs';
    const navigationViewportBreakpoint = getNavigationViewportMediaQueryLists().find(({ mediaQueryList }) => mediaQueryList.matches);
    return (_a = navigationViewportBreakpoint === null || navigationViewportBreakpoint === void 0 ? void 0 : navigationViewportBreakpoint.size) !== null && _a !== void 0 ? _a : 'sm';
};
